module.exports = "<div class=\"bspinner\">\r\n    <div class=\"bounce1\"></div>\r\n    <div class=\"bounce2\"></div>\r\n    <div class=\"bounce3\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/views/thinker.html
// module id = 447
// module chunks = 1